export const BOOLEAN_EDITOR_OPTIONS = [
  {name: 'Yes', value: true},
  {name: 'No', value: false},
];
